import React from "react";
import ReactDOM from "react-dom";
import Citation from "./components/citation";

const citation = document.getElementById("citation");
const doi = citation.getAttribute("doi");

ReactDOM.render(<Citation doi={doi} />, citation);
